import { useTranslation } from 'react-i18next';
import { InvalidPermissionsError } from '@/router/components/ScheduleLoader/InvalidPermissionsError';
import {
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@/ui';
import { useRequestAccessModal } from './store';

export const RequestAccessModal = () => {
  const { t } = useTranslation('rsvpBar');
  const { isOpen, close } = useRequestAccessModal();

  return (
    <Modal isCentered isOpen={isOpen} size="xl" onClose={close}>
      <ModalOverlay />

      <ModalContent p="6">
        <ModalCloseButton />
        <ModalBody as={Flex} direction="column" gap="4">
          <InvalidPermissionsError title={t('request_access_title')} />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
